import EventHandler from '@pixelunion/events';

export default class TemplateLogin {
  constructor() {
    this.events = new EventHandler();
    this.adminLogin = document.querySelector('.admin-login-modal');

    this.events.register(this.adminLogin, 'click', () => this.openModal());
    this.events.register(document.body, 'click', event => this.closeModal(event));

    this.modalWrapper = document.querySelector('.password-page-modal-wrapper');
    this.modalContent = this.modalWrapper.querySelector('.password-page-modal');
    this.modalInput = this.modalWrapper.querySelector('.password-page-input');

    if (this.modalWrapper.querySelector('[data-open-modal]')) {
      this.openModal();
    }

    this.events.register(window, 'resize', () => this.positionModal());
  }

  closeModal(e) {
    if (e.target.classList.contains('visible')) {
      this.modalWrapper.classList.remove('visible');
      this.events.register(this.modalWrapper, 'transitionend', () => {
        document.body.classList.remove('scroll-locked');
      });
    }
  }

  openModal() {
    document.body.classList.add('scroll-locked');
    this.positionModal();
    this.modalWrapper.classList.add('visible');
    this.events.register(this.modalWrapper, 'transitionend', () => {
      this.modalInput.focus();
    });
  }

  positionModal() {
    const { width, height } = this.modalContent.getBoundingClientRect();
    this.modalContent.style.marginTop = -(height / 2);
    this.modalContent.style.marginLeft = -(width / 2);
  }

  unload() {
    if (this.events) {
      this.events.unregisterAll();
    }
  }
}
